import { render, staticRenderFns } from "./AppAsistencia.vue?vue&type=template&id=b70004fa&scoped=true&"
import script from "./AppAsistencia.vue?vue&type=script&lang=js&"
export * from "./AppAsistencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70004fa",
  null
  
)

export default component.exports